import Typography, { TypographyProps } from "@material-ui/core/Typography";
import React from "react";
import { HERO_SUBTITLE_ID_CONTAINER } from "../../../../constants";
import { ColorTypes, useWidgetTextColorFromType } from "../hooks";

interface SubtitleProps extends TypographyProps {
  colorType?: ColorTypes;
}

export const Subtitle: React.FC<SubtitleProps> = ({ children, colorType, ...props }) => {
  const colorStyle = useWidgetTextColorFromType(colorType);
  return (
    <Typography
      variant="body2"
      color="inherit"
      style={colorStyle}
      {...props}
      data-id={HERO_SUBTITLE_ID_CONTAINER}
    >
      {children}
    </Typography>
  );
};
